// extracted by mini-css-extract-plugin
export var closeButton = "_4c-3";
export var header = "_4c-0";
export var link = "_4c-1";
export var retryButton = "_4c-2";